import { render, staticRenderFns } from "./grid-gallery.vue?vue&type=template&id=deb73bc6&"
import script from "./grid-gallery.vue?vue&type=script&lang=js&"
export * from "./grid-gallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports